export var entityFieldMutationValue = function (value, field) {
  var _a, _b;
  switch (field.formFieldType) {
    case 'longText':
      return value === null || value === void 0 ? void 0 : value.text;
    case 'file':
    case 'image':
      return (value === null || value === void 0 ? void 0 : value.url) || '';
    case 'linked':
      return value === null || value === void 0 ? void 0 : value.id;
    case 'linkedMultiple':
      return (_a = value === null || value === void 0 ? void 0 : value.map) === null || _a === void 0 ? void 0 : _a.call(value, function (v) {
        return v.id;
      });
    case 'linkedJunction':
      return (_b = value === null || value === void 0 ? void 0 : value.map) === null || _b === void 0 ? void 0 : _b.call(value, function (v) {
        return v.id;
      });
    default:
      return value;
  }
};